import React, { useEffect, createElement } from 'react';
import AdvertorialRlt1 from '../components/AdvertorialRlt1';
import { HelmetProvider, Helmet } from 'react-helmet-async';
// Declare fbq and gtag for TypeScript
declare global {
  interface Window {
    fbq: any;
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}
export function Rlt1Page() {
  useEffect(() => {
    // Initialize Facebook Pixel with safety checks
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safety check: if no script elements exist, append to head instead
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with your Pixel ID
    window.fbq('init', '893117086060970');
    window.fbq('track', 'PageView');
    // Track ViewContent for this advertorial
    window.fbq('track', 'ViewContent', {
      content_name: 'Red Light Therapy Investigation - RLT-1',
      content_category: 'Health',
      content_type: 'article'
    });
    // Initialize Google Tag Manager dataLayer FIRST
    window.dataLayer = window.dataLayer || [];
    window.gtag = function (...args: any[]) {
      window.dataLayer.push(args);
    };
    // Load gtag.js script dynamically
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-17548177287';
    document.head.appendChild(gtagScript);
    // Configure Google Tag Manager after script loads
    gtagScript.onload = () => {
      window.gtag('js', new Date());
      window.gtag('config', 'AW-17548177287', {
        send_page_view: true
      });
    };
    // Store fbclid in localStorage if present in URL
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      localStorage.setItem('fbclid', fbclid);
    }
    // Set up scroll depth tracking - UPDATED CUSTOM EVENTS
    let tracked50 = false;
    let tracked90 = false;
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
      if (!tracked50 && scrollPercent > 50) {
        window.fbq('trackCustom', 'Advertorial_Scroll_50');
        tracked50 = true;
      }
      if (!tracked90 && scrollPercent > 90) {
        window.fbq('trackCustom', 'Advertorial_Scroll_90');
        tracked90 = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <HelmetProvider data-id="element-18694">
      <div className="w-full min-h-screen bg-gray-100" data-id="element-18695">
        <Helmet data-id="element-18696">
          <script async src="https://www.googletagmanager.com/gtag/js?id=AW-17548177287" data-id="element-18697"></script>
          <script data-id="element-18698">
            {`
            window.dataLayer = window.dataLayer || []; 
            function gtag() {dataLayer.push(arguments);}
            gtag('js', new Date()); 
            gtag('config', 'AW-17548177287');
            gtag('event', 'conversion', {'send_to': 'AW-17548177287/xQtBCOLL2LsbEIffz69B'});
            `}
          </script>
          <title data-id="element-18699">
            PhD Exercise Physiologist Investigates: Is Red Light Therapy for Fat
            Loss a Scam—Or Are Most Devices Just Built Wrong?
          </title>
          <meta property="og:title" content="PhD Exercise Physiologist Investigates: Is Red Light Therapy for Fat Loss a Scam—Or Are Most Devices Just Built Wrong?" data-id="element-18700" />
          <meta property="og:description" content="A 3-month investigation with 14 volunteers revealed why most red light therapy devices fail to deliver clinical results. The difference isn't the wavelength—it's how the light is delivered to the fat cells." data-id="element-18701" />
          <meta property="og:type" content="article" data-id="element-18702" />
          <meta property="og:url" content={window.location.href} data-id="element-18703" />
          <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18704" />
          <meta property="og:image:width" content="1200" data-id="element-18705" />
          <meta property="og:image:height" content="630" data-id="element-18706" />
          <meta property="og:site_name" content="Health Investigation Series" data-id="element-18707" />
          <meta name="twitter:card" content="summary_large_image" data-id="element-18708" />
          <meta name="twitter:title" content="PhD Exercise Physiologist Investigates: Is Red Light Therapy for Fat Loss a Scam—Or Are Most Devices Just Built Wrong?" data-id="element-18709" />
          <meta name="twitter:description" content="A 3-month investigation with 14 volunteers revealed why most red light therapy devices fail to deliver clinical results. The difference isn't the wavelength—it's how the light is delivered to the fat cells." data-id="element-18710" />
          <meta name="twitter:url" content={window.location.href} data-id="element-18711" />
          <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18712" />
        </Helmet>
        <AdvertorialRlt1 data-id="element-18713" />
      </div>
    </HelmetProvider>;
}